import {
  createMessageDispatcherMiddleware,
  createMessageRecieverMiddleware
} from 'redux-postmessage-middleware';
import { getRailsUrl } from 'utilities/integration/rails';

const sendingFrom = window.location.origin;
const sendingTo = getRailsUrl('');

export const messageDispatcherMiddleware = createMessageDispatcherMiddleware({
  senderURL: sendingFrom,
  parentURL: sendingTo,
  targetURLs: [sendingFrom, sendingTo],
});

export const messageReceiverMiddleware = createMessageRecieverMiddleware({
  allowedURLs: [sendingFrom, sendingTo],
});
